import React from 'react';
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = {
    page: {
        padding: 20,
        fontSize: 10,
    },
    title: {
        fontSize: 18,
        textAlign: "center",
        marginBottom: 20,
        fontWeight: "bold",
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#d9d9d9",
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCol: {
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#d9d9d9",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 8,
        textAlign: "center",
    },
    tableHeader: {
        backgroundColor: "#f5f5f5",
        fontWeight: "bold",
        fontSize: 12,
    },
    tableCell: {
        margin: 0,
        padding: 2,
    },
    stripedRow: {
        backgroundColor: "#fafafa",
    },
    headerContainer: {
        marginBottom: 10,
        textAlign: "center",
    }
};

const columns = [
    { header: 'SI.No', key: 'si_no', width: '6%' },
    { header: 'Bin ID', key: 'bin_id', width: '8%'},
    { header: 'BM ID', key: 'bm_id', width: '8%' },
    { header: 'Batch ID', key: 'batch_id' },
    { header: 'Bin From', key: 'bin_from' }, 
    { header: 'Bin To', key: 'bin_to' },
    { header: 'Movement Status', key: 'movement_status' },
    { header: 'Received By', key: 'received_by' },
    { header: 'Received On', key: 'received_on' },
];

const formatColumnData = (value) => {
    switch(value) {
        case "garment_super_market": return "Garment Super Market";
        case "dispatch_center": return "Dispatch Center";
        case "washing": return "Washing";
        default: return value;
    }
};

const InwardOutward_Report = ({ reportData, startDate, endDate }) => {
    const rowsPerPage = 10;
    const pages = [];
    
    for (let i = 0; i < reportData.length; i += rowsPerPage) {
        pages.push(reportData.slice(i, i + rowsPerPage));
    }

    return (
        <Document>
            {pages.map((pageData, pageIndex) => (
                <Page key={pageIndex} size="A4" orientation="landscape" style={styles.page} wrap>
                    <View style={styles.headerContainer} fixed>
                        <Text style={styles.title}>Report from {startDate} to {endDate}</Text>
                    </View>
                    <View style={styles.table} fixed>
                        <View style={[styles.tableRow, styles.tableHeader]}>
                            {columns.map((col) => (
                                <View style={[styles.tableCol, { flex: 1 }]} key={col.key}>
                                    <Text style={styles.tableCell}>{col.header}</Text>
                                </View>
                            ))}
                        </View>
                    </View>
                    <View style={styles.table}>
                        {pageData.map((row, index) => (
                            <View style={[styles.tableRow, index % 2 === 1 && styles.stripedRow]} key={index}>
                                {columns.map((col, i) => (
                                    <View style={[styles.tableCol, { flex: 1 }]} key={i}>
                                        <Text style={styles.tableCell}>{formatColumnData(row[col.key]) || ''}</Text>
                                    </View>
                                ))}
                            </View>
                        ))}
                    </View>
                </Page>
            ))}
        </Document>
    );
};

export default InwardOutward_Report;
